export const blueCardAlphaPrefixesColumns = [
  'prefix',
  'homePlan',
  'startDate',
  'endDate',
  'plan',
  'planDetail',
  'blueCardEligible',
  'blueShieldOnly',
  'blueCrossOnly',
  'notes',
  'federal',
  'medicalAdvantagePlan',
  'state',
];
